import { ProgressSpinner, TablePagination } from '@repo/atomic-components';
import { useMedicalRecordsListTable } from './hooks';
import { MedicalRecordsListTable, GdprCheckSummaryModal, CaseSelectorPopup, ProviderSelectorPopup } from './components';
import { MEDICAL_RECORDS_DELETE_DOCUMENT } from '@/constants';
import { WarningConfirmationDialog } from '@/ui/components/WarningConfirmationDialog';
import { PaginatorInfoDialog } from '@/ui/components/PaginatorInfoDialog';

export const MedicalRecordsPage = () => {
  const {
    table,
    filterOptions,
    selectedFilterOptions,
    selectedUploadDateRange,
    handleFilterChange,
    handleUploadedByFilterChange,
    isTableDataLoading,
    gdprSummaryVisible,
    setGdprSummaryVisible,
    gdprSummaryData,
    gdprSummaryLoading,
    caseSelectorVisible,
    setCaseSelectorVisible,
    caseSelectorPosition,
    casesBasicList,
    handleCaseSelect,
    providerSelectorVisible,
    setProviderSelectorVisible,
    providerSelectorPosition,
    caseProvidersList,
    handleProviderSelect,
  } = useMedicalRecordsListTable();

  return (
    <>
      <PaginatorInfoDialog />
      <WarningConfirmationDialog
        id={MEDICAL_RECORDS_DELETE_DOCUMENT}
        bodyText="The selected document will be permanently deleted."
        confirmLabel="Delete"
      />
      <GdprCheckSummaryModal
        visible={gdprSummaryVisible}
        onHide={() => setGdprSummaryVisible(false)}
        summaryData={gdprSummaryData}
        isLoading={gdprSummaryLoading}
      />
      {caseSelectorVisible && (
        <CaseSelectorPopup
          casesBasicList={casesBasicList}
          onSelect={handleCaseSelect}
          onClose={() => setCaseSelectorVisible(false)}
          position={caseSelectorPosition}
        />
      )}
      {providerSelectorVisible && (
        <ProviderSelectorPopup
          caseProvidersList={caseProvidersList}
          onSelect={handleProviderSelect}
          onClose={() => setProviderSelectorVisible(false)}
          position={providerSelectorPosition}
        />
      )}

      <div className="bg-fletchers-gray-25 flex h-full w-full flex-col overflow-hidden px-6 pb-4">
        <div className="relative flex h-full w-full flex-row overflow-hidden">
          {/* Bordered table card with internal vertical scroll. `px-2`
              gives 8px breathing room between the table content and the
              border. `overflow-x-hidden overflow-y-auto` shows the
              vertical scrollbar only when rows overflow; the horizontal
              bar is suppressed because the JS-driven spacer logic keeps
              the table at 100% width. */}
          <div className="bg-fletchers-white border-fletchers-gray-110 h-full w-full overflow-x-hidden overflow-y-auto rounded-lg border px-2">
            <MedicalRecordsListTable
              table={table}
              filterOptions={filterOptions}
              selectedFilterOptions={selectedFilterOptions}
              selectedUploadDateRange={selectedUploadDateRange}
              handleFilterChange={handleFilterChange}
              handleUploadedByFilterChange={handleUploadedByFilterChange}
            />
          </div>
          {isTableDataLoading && (
            <div className="pointer-events-none absolute top-0 left-0 flex h-full w-full items-center justify-center">
              <ProgressSpinner style={{ width: '100px', height: '100px' }} strokeWidth="4" animationDuration="1.5s" />
            </div>
          )}
        </div>
        <div className="mt-auto flex justify-center">
          <TablePagination table={table} appearance={{ dividerClassName: 'hidden' }} />
        </div>
      </div>
    </>
  );
};
